import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { Auth } from '../../services/auth';
import { Title } from '../../services/title';

@Component({
  selector: 'app-layout',
  imports: [RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './layout.html',
  styles: ``,
})
export class Layout implements OnInit {
  private readonly authService = inject(Auth);
  readonly titleService = inject(Title);

  fullName = '';
  isSidebarOpen = signal(true);

  ngOnInit(): void {
    this.fullName =
      this.authService.session()?.user.user_metadata['name'] || 'User';
  }

  toggleSidebar() {
    this.isSidebarOpen.update((v) => !v);
  }

  nameInitials() {
    const arr = this.fullName.split(' ');
    return `${arr[0][0]}${arr[arr.length - 1][0]}`;
  }

  userRole() {
    const role = this.authService.session()?.user.app_metadata['role'];
    switch (role) {
      case 'ADMIN':
        return 'Administrateur';
      default:
        return '';
    }
  }

  isAdmin() {
    return this.authService.session()?.user.app_metadata['role'] === 'ADMIN';
  }

  logout() {
    this.authService.logout();
  }
}
